import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as CheckIcon} from 'static/svg/icon-check-green.svg'
import LineSeparator from 'components/LineSeparator'

import * as S from './styles'

export const RegisterCompleteFeedback = (): JSX.Element => {
  return (
    <S.Container>
      <CheckIcon />
      <Typography variant='header4' weight='bold'>
        Cadastro completado com sucesso!
      </Typography>
      <Typography variant='content2' center>
        Caso precise modificar estes dados futuramente, acesse o menu de sua conta e vá em <em>“Configurações”</em>.
      </Typography>
      <LineSeparator 
        lineColor='#c1c1c1'
        lineWidth='100%'
        lineHeight='1px'
        lineMargin='40px'
      />
    </S.Container>
  )
}